import theme from 'styles/token/color';
import styled, { css } from 'styled-components';

import { scrollBar } from 'styles/commons/scrollBar';

// 스타일드 컴포넌트를 사용하여 모달 스타일 설정
const ModalOverlay = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  pointer-events: none;
  display: ${({ visible }) => (visible === 'true' ? 'block' : 'none')};

  ${({ className }) => modalClassName[className] || ''}

  &.address_modal {
    .modal_inner {
      @media screen and (max-width: 768px) {
        max-width: ${({ width }) =>
          width === undefined ? 'fit-content' : width};
        left: 0 !important;
        top: 50% !important;
        transform: translateY(-50%);
      }

      .modal_header {
        @media screen and (max-width: 768px) {
          padding: 12px 40px 12px 12px;
        }
        .close_btn {
          @media screen and (max-width: 768px) {
            top: 12px;
          }
        }
      }
      .address_info {
        @media screen and (max-width: 768px) {
          margin-bottom: 0;
        }
      }
    }
  }
`;

const ModalInner = styled.div`
  max-width: ${({ width }) => (width === undefined ? '560px' : width)};
  width: 100%;
  background: ${theme.color.white};
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 20%);
  border-radius: 8px; // 모서리 둥글게 설정

  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media screen and (max-width: 768px) {
    /* position: absolute; */
    margin: 24px 16px;
    /* left: 0 !important;
    top: 50% !important;
    transform: translateY(-50%); */
  }
`;

const ModalArea = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  pointer-events: auto;

  &:before,
  &:after {
    content: '';
    display: block;
    flex: 1 1 0%;
    background: rgba(0, 0, 0, 0.5);
  }
`;
const ModalFrame = styled.div`
  display: flex;
  height: 83.3%;
  flex: 0 1 0%;
  pointer-events: auto;
  background: rgba(0, 0, 0, 0.5);

  &:before,
  &:after {
    content: '';
    display: block;
    flex: 1 1 0%;
  }
`;

const ModalHeader = styled.div`
  position: relative;
  width: 100%;
  padding: 40px 32px 12px;
  text-align: center;

  @media screen and (max-width: 768px) {
    // padding: 24px 24px 12px;
    padding: 24px 44px 12px 12px;
  }

  h2 {
    font-size: 18px;
    letter-spacing: -0.015px;
    font-weight: 500;
    line-height: 1.6;
  }
  .header_desc {
    margin-top: 16px;
    word-break: break-all;
    color: ${theme.color.gray500};
    font-size: 13px;
    font-weight: 300;
  }
  .close_btn {
    position: absolute;
    top: 40%;
    right: 20px;
    transform: translateY(-50%);
    @media screen and (max-width: 768px) {
      right: 8px;
    }

    svg {
      font-size: 14px;
      @media screen and (max-width: 768px) {
        stroke: ${theme.color.gray600};
        fill: ${theme.color.gray600};
      }
    }
  }
`;

const ModalContent = styled.div`
  width: 100%;
  padding: 12px 32px 32px;
  overflow: auto;
  max-height: 800px;
  /* height: 90%; */

  @media screen and (max-width: 768px) {
    padding: 16px 12px 24px;
    word-break: keep-all;
    max-height: 480px;
  }

  &.app_change_select {
    ${scrollBar.default}
    max-height: calc(100vh - 250px);
  }
  &.modal_column {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
`;

//  // 단독 코멘트만 있는 경우 스타일
//  &.comment {
//   font-size: 14px;
//   text-align: center;
// }
// .field_item {
//   width: 100%;
// }
// .cont_desc {
//   display: inline-block;
//   width: 100%;
//   margin-bottom: 24px;
//   text-align: center;
//   word-break: break-all;
//   color: ${theme.color.gray500};
//   font-size: 13px;
//   font-weight: 300;
// }
// &.app_change_select {
//   padding: 0 20px 42px;
// }

const ModalFooter = styled.div`
  padding: 10px 32px 30px;
`;

const modalClassName = {
  signup_modal: css`
    touch-action: auto;
    .modal_inner {
      max-width: 420px;
    }
    .modal_header {
      @media screen and (max-width: 768px) {
        padding: 24px 44px 12px 56px;
      }
    }
    .modal_content {
      overflow: initial;
    }
  `,
  signup_success_modal: css`
    .modal_inner {
      padding: 20px;
    }
    .confirm_btn {
      width: 120px;
    }
  `,
  address_modal: css`
    .modal_inner {
      max-width: 500px;
    }
    .modal_header {
      display: flex;
      flex-direction: column;
    }
  `,
  dev_modal: css`
    .modal_header {
    }
    .modal_content {
      .modal_content_desc {
        margin: 0;
        border: 0;
        padding: 0;
        p {
          line-height: 2;
        }
      }
    }
  `,
};

export const modal = {
  Overlay: ModalOverlay,
  Inner: ModalInner,
  Area: ModalArea,
  Frame: ModalFrame,
  Header: ModalHeader,
  Content: ModalContent,
  Footer: ModalFooter,
};
